import React, { useState, useEffect } from 'react';
import 'swiper/css'; // Swiper CSS
import 'swiper/css/pagination'; // Swiper Pagination CSS
import 'swiper/css/autoplay'; // Swiper Autoplay CSS
import { Pagination, Autoplay } from 'swiper/modules'; // Swiper Modules
import { Swiper, SwiperSlide } from 'swiper/react'; // Swiper React Components
import "./tpoLogin.css";

import "../login/css/ea-style-new.css";
import "../login/css/superfish-new_2.css";
import "../login/css/swiper.min.css";

const HeroLogin = () => {

    const [showSupportPopup, setShowSupportPopup] = useState(false);
    const [showMobileSupportPopup, setShowMobileSupportPopup] = useState(false);
    const [openIndex, setOpenIndex] = useState(null);

    const handleAccordionClick = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    const accordionData = [
        {
            title: 'company',
            content: (
                <>
                    <p><a href="https://www.champstpo.com/who-we-are" target="_blank"><span>About</span></a></p>
                    <p><a href="https://www.champstpo.com/news" target="_blank"><span>News</span></a></p>
                    <p><a href="https://www.champstpo.com/licenses" target="_blank"><span>State Licensing</span></a></p>
                </>
            ),
        },
        {
            title: 'Resources',
            content: (
                <>
                    <p><a href="https://www.champstpo.com/partner-with-us" target="_blank"><span>Products</span></a></p>
                    <p><a href="https://www.champstpo.com/broker-resources" target="_blank"><span>Broker Forms & Guidelines</span></a></p>
                    <p><a href="https://www.champstpo.com/broker-training" target="_blank"><span>Broker Training</span></a></p>
                    <p><a href="https://www.champstpo.com/homeowner-education" target="_blank"><span>Homeowner Resources</span></a></p>
                </>
            ),
        },
        {
            title: 'Contact Us',
            content: (
                <>
                    <p>1.888.210.9881</p>
                    <p><a href="mailto:clientcare@champstpo.com"><span>clientcare@champstpo.com</span></a></p>
                    <br />
                    <p>365 E Germann Rd, Suite 140</p>
                    <p>Gilbert, AZ 85297</p>
                    <p>United States</p>
                    <p>NMLS ID #2254210</p>
                </>
            ),
        },
        {
            title: 'For Customer Support/Loan Payment Options',
            content: <p>1.855.436.0977</p>,
        },
    ];

    const sliderData = [
        {
            DocId: "425a2033-6ff0-46d6-817c-e5f89d9d2f06",
            DocTitle: "Accelerator Full/Alt-Doc Announcement",
            LinkUrl: "https://www.champstpo.com/forms-guidelines",
            DocType: 2,
            UploadImage: "content/Images/slider/CF_Social_Accelerator_FullAltDoc_Login_(1).png",
        },
        {
            DocId: "a61c6b39-0494-4dc8-a9b0-3df49bf9ace8",
            DocTitle: "New Website is Here!",
            DocType: 0,
            UploadImage: "content/Images/slider/CF_NewWebsite_Graphcs_Login.png",
        },
        {
            DocId: "afdaa8fe-a3aa-4fd3-94c2-9971ba877cff",
            DocTitle: "Page 4",
            DocType: 3,
            UploadImage: "content/Images/slider/HERO-Login-3.png",
        },
    ];

    const handleSupportClick = () => {
        setShowSupportPopup(!showSupportPopup);
    };

    const handleMobileSupportClick = () => {
        setShowMobileSupportPopup(!showMobileSupportPopup);
    };

    // Dropdown state for each menu
    const [openDropdown, setOpenDropdown] = useState(null);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClick = (e) => {
            if (
                !e.target.closest('.menu-btn') &&
                !e.target.closest('.dropdown-menu')
            ) {
                setOpenDropdown(null);
            }
        };
        document.addEventListener('mousedown', handleClick);
        return () => document.removeEventListener('mousedown', handleClick);
    }, []);

    const handleDropdown = (menu) => {
        setOpenDropdown(openDropdown === menu ? null : menu);
    };

    return (
        <>
            <div className="login-page">
                <div className="app_container">
                    {/* Navigation Links */}
                    <ul className="hero-nav hero-header-layout visible-lg" style={{ display: 'flex', alignItems: 'center' }}>
                        <li className="hero-logo">
                            <img
                                src="content/Images/Hero-2.0-Logo-Horizontal-2.0.png"
                                alt="HERO 2.0 Logo"
                            />
                        </li>
                        {/* Flex spacer to push menus right */}
                        <li style={{ flexGrow: 1, pointerEvents: 'none', background: 'none', boxShadow: 'none' }}></li>
                        {/* Wholesale Resources Dropdown */}
                        <li style={{ position: 'relative', zIndex: 1001 }}>
                            <button
                                className="menu-btn"
                                tabIndex={0}
                                onClick={() => handleDropdown('wholesale')}
                                aria-haspopup="true"
                                aria-expanded={openDropdown === 'wholesale'}
                            >
                                Wholesale Resources
                            </button>
                            {openDropdown === 'wholesale' && (
                                <ul className="dropdown-menu">
                                    <li><a href="https://www.champstpo.com/our-story" target="_blank" rel="noopener noreferrer">About</a></li>
                                    <li><a href="https://www.champstpo.com/programs" target="_blank" rel="noopener noreferrer">Products</a></li>
                                    <li><a href="https://www.champstpo.com/forms-guidelines" target="_blank" rel="noopener noreferrer">Broker Resources</a></li>
                                    <li><a href="https://www.champstpo.com/broker-training" target="_blank" rel="noopener noreferrer">Broker Training</a></li>
                                    <li><a href="https://www.champstpo.com/#QuickPricer" target="_blank" rel="noopener noreferrer">Quick Pricer</a></li>
                                </ul>
                            )}
                        </li>
                        {/* Correspondent Resources Dropdown */}
                        <li style={{ position: 'relative', zIndex: 1001 }}>
                            <button
                                className="menu-btn"
                                tabIndex={0}
                                onClick={() => handleDropdown('correspondent')}
                                aria-haspopup="true"
                                aria-expanded={openDropdown === 'correspondent'}
                            >
                                Correspondent Resources
                            </button>
                            {openDropdown === 'correspondent' && (
                                <ul className="dropdown-menu">
                                    <li><a href="https://www.champscorr.com/about-us" target="_blank" rel="noopener noreferrer">About</a></li>
                                    <li><a href="https://www.champscorr.com/correspondent-products" target="_blank" rel="noopener noreferrer">Products</a></li>
                                    
                                </ul>
                            )}
                        </li>
                    </ul>

                    {/* Triangles for Design */}
                    {/* <div className="triangle visible-lg"></div>
                    <div className="triangle1 visible-lg"></div> */}

                    {/* Main content */}
                    <div className="content col-xs-12">
                        <div
                            className="content col-xs-12"
                            style={{
                                backgroundImage: "url('content/Images/HEROLogin_BG_72dpi-2.png')",
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                backgroundRepeat: "no-repeat",
                                //minHeight: "500px", // adjust as needed
                                position: "relative" // for any absolute positioned children
                            }}
                        >
                        </div>
                        {/* Left Section */}
                        {/* <div className="left col-lg-6 col-xs-12">
                            <div className="bottom">
                                <p className="powered">Powered by</p>
                                <img src="content/Images/logo_champs.png" alt="Champs Logo" />
                                <p className="funding">© 2024 Champions Funding</p>
                            </div>
                        </div> */}

                        {/* Right Section - Swiper Slider */}
                        {/* <div className="right col-lg-6 col-xs-12">
                            <div className="swiper_div col-xs-12">
                                <Swiper
                                    modules={[Pagination, Autoplay]} // Pass Swiper modules here
                                    pagination={{ clickable: true }}
                                    autoplay={{ delay: 5000 }}
                                    loop={true}
                                >
                                    {sliderData.map((slide, index) => (
                                        <SwiperSlide key={index}>
                                            {slide.DocType === 2 ? (
                                                <a href={slide.LinkUrl} target="_blank" rel="noopener noreferrer">
                                                    <img src={slide.UploadImage} alt={slide.DocTitle} />
                                                </a>
                                            ) : (
                                                <img src={slide.UploadImage} alt={slide.DocTitle} />
                                            )}
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>
                        </div> */}
                    </div>



                </div>

                <p style={{ margin: "0", background: "#fff", position: "relative", top: "18px", height: "18px" }} class="visible-lg"> </p>
                {/* Footer Section */}
                <div className="new-footer hidden-xs">
                    {/* <div class="support">
                        <span style={{ zIndex: 999 }} onClick={handleSupportClick}><img src="content/Images/new/chat.png" alt="" />Contact Support</span>
                        {showSupportPopup && (
                            <div style={{ zIndex: 999, overflow: "hidden", display: "block" }} class="contactSupport">
                                <div class="contactSupportTitle"><img src="content/Images/new/chat.png" alt="" />Contact Support
                                </div>
                                <div style={{ zIndex: 999 }} class="contactSupportList">
                                    <label>How can we help you, Mortgage Champ? Send us a message.</label>
                                    <label for="name">
                                        <div class="must_fill">*</div>Name:
                                        <input id="name" class="v_name" type="text" />
                                        <div class="eva_validator">Please enter.</div></label>
                                    <label for="phone">
                                        Phone Number:
                                        <input id="phone" type="text" />
                                    </label>
                                    <label for="email">
                                        <div class="must_fill">*</div>Preferred E-mail:
                                        <input id="email" class="v_mail" type="text" />
                                        <div class="eva_validator">Please enter.</div></label>
                                    <label for="number">
                                        Loan #:
                                        <input id="number" type="text" />
                                    </label>
                                    <label for="comment">
                                        <div class="must_fill">*</div>Message:
                                        <textarea id="comment" class="v_message" rows="3" cols="20"></textarea>
                                        <div class="eva_validator">Please enter.</div></label>
                                    <input type="button" id="submit" class="button_small primary_normal primary_hover primary_down submit_button" value="Submit" />
                                    <input type="button" id="cancel" class="button_small Secondary_normal Secondary_hover Secondary_active cancel_button" value="Cancel" onClick={handleSupportClick} />
                                </div>
                            </div>
                        )}
                    </div> */}

                    {/* Footer Links */}
                    <div class="con">
                        <ul class="content">
                            <li style={{ width: "20%" }}>
                                <p class="title">Powered by</p>
                                <img src="content/Images/logo_champs.png" alt="" />
                                <hr style={{
                                    borderColor: '#c0cbd6',
                                    borderWidth: '1px',
                                    borderLeft: 'none',
                                    borderRight: 'none',
                                    borderStyle: 'solid',
                                    margin: '6px 0',
                                }} />
                                <ul class="share_ul">
                                    <a href="https://www.linkedin.com/company/champions-funding" target="_blank">
                                        <img src="content/Images/Medium%20Blue/LinkedIn/26.png" alt="" />
                                    </a>
                                    <a href="https://www.instagram.com/champstpo/" target="_blank"><img src="content/Images/Medium%20Blue/Instagram/26.png" alt="" /></a>
                                    <a href="https://www.facebook.com/champstpo" target="_blank">
                                        <img src="content/Images/Medium%20Blue/Facebook/26.png" alt="" />
                                    </a>
                                    <a href="https://twitter.com/champstpo/" target="_blank"><img src="content/Images/Medium%20Blue/Twitter/26.png" alt="" /></a>
                                    <a href="https://www.youtube.com/channel/UCDjCfJQVIRHjN9VXidYDVdA" target="_blank">
                                        <img src="content/Images/Medium%20Blue/Youtube/26.png" alt="" />
                                    </a>
                                </ul>
                            </li>

                             <li style={{ width: "21%", paddingLeft: "5%" }}>
                                <p class="title">Wholesale Resources</p>
                                <p><a href="https://www.champstpo.com/" target="_blank"><span>ChampsTPO.com</span></a></p>
                                <p><a href="https://www.champstpo.com/our-story" target="_blank"><span>About</span></a></p>
                                <p><a href="https://www.champstpo.com/programs" target="_blank"><span>Products</span></a></p>
                                <p><a href="https://www.champstpo.com/licenses" target="_blank"><span>State Licensing</span></a></p>
                                <p><a href="https://www.champstpo.com/forms-guidelines" target="_blank"><span>Broker Resources</span></a></p>
                                <p><a href="https://www.champstpo.com/broker-training" target="_blank"><span>Broker Training</span></a></p>
                                <p><a href="https://www.champstpo.com/homeownership-counseling" target="_blank"><span>Homeownership Counseling</span></a></p>
                            </li>
                            <li style={{ width: "18%" }}>
                                <p class="title">Correspondent Resources</p>
                                <p><a href="https://www.champscorr.com/" target="_blank"><span>ChampsCorr.com</span></a></p>
                                <p><a href="https://www.champscorr.com/about-us" target="_blank"><span>About</span></a></p>
                                <p><a href="https://www.champscorr.com/correspondent-products" target="_blank"><span>Products</span></a></p>
                                <p><a href="https://www.champscorr.com/licenses" target="_blank"><span>State Licensing</span></a></p>
                            </li>
                            <li style={{ width: "23%" }}>
                                <p class="title">Contact Us</p>
                                <p>1.888.210.9881</p>
                                <p><a href="mailto:clientcare@champstpo.com"><span>clientcare@champstpo.com</span></a></p>
                                <br />
                                <p>365 E Germann Rd, Suite 140</p>
                                <p>Gilbert, AZ 85297</p>
                                <p>United States</p>
                                <p>NMLS ID #2254210</p>
                            </li>
                            <li style={{ width: "18%" }}>
                                <p class="title" style={{ margin: "10px 0 0" }}>For Customer Support/</p>
                                <p class="title" style={{ margin: "5px 0 10px" }}>Loan Payment Options</p>
                                <p>1.855.436.0977</p>
                                <p><img style={{ marginTop: "40px" }} src="content/Images/new/cdfi.png" alt="" /></p>
                            </li>
                        </ul>
                    </div>

                    {/* Bottom Info Section */}
                    <div className="bottom-info">
                        <div>
                            <img src="content/Images/new/ehl.png" alt="Equal Housing Opportunity" />
                            <div>
                                <p>For Equal Housing Opportunity.</p>
                                <p>
                                    © 2026 All Rights Reserved. For industry professionals only and is not an advertisement to extend credit directly to consumers. For licensing, visit <a href="http://nmlsconsumeraccess.org/" target="_blank" rel="noopener noreferrer">nmlsconsumeraccess.org</a>.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="new-footer-mobile visible-xs">
                    <div style={{ marginTop: "15px", background: "#f3f7fc" }}>
                        <div class="support support_mobile">
                            <span><img src="content/Images/new/chat.png" alt="" /></span>
                        </div>
                        <div class="title">
                            <p class="title">Powered by</p>
                            <img src="content/Images/Hero-Logo-Horizontal.png" alt="" />
                        </div>
                        <div class="share_ul">
                            <a href="https://www.linkedin.com/company/champions-funding" target="_blank">
                                <img src="content/Images/linkedin1.png" alt="" />
                            </a>
                            <a href="https://www.instagram.com/champstpo/" target="_blank"><img src="content/Images/ins1.png" alt="" /></a>
                            <a href="https://www.facebook.com/champstpo" target="_blank">
                                <img src="content/Images/facebook1.png" alt="" />
                            </a>
                            <a href="https://twitter.com/champstpo/" target="_blank"><img src="content/Images/twitter1.png" alt="" /></a>
                            <a href="https://www.youtube.com/channel/UCDjCfJQVIRHjN9VXidYDVdA" target="_blank">
                                <img src="content/Images/youtube1.png" alt="" />
                            </a>
                        </div>
                        <ul className="accordion" id="accordion">
                            {accordionData.map((item, index) => (
                                <li key={index}>
                                    <p className="accordion-control" onClick={() => handleAccordionClick(index)}>
                                        {item.title}
                                        <img
                                            src={openIndex === index ? '/content/Images/Dark Blue/chevron-down/32.png' : 'content/Images/Dark Blue/chevron-right/32.png'}
                                            alt=""
                                            className={openIndex === index ? 'isOpen' : ''}
                                        />
                                    </p>
                                    <div
                                        className="accordion-panel"
                                        style={{
                                            overflow: 'hidden',
                                            display: openIndex === index ? 'block' : 'none',
                                        }}
                                    >
                                        {item.content}
                                    </div>
                                </li>
                            ))}
                        </ul>
                        <div class="mobile_bottom">
                            <p><img src="content/Images/new/cdfi.png" alt="" /></p>
                            <p>365 E Germann Rd, Suite 140 Gilbert, AZ 85297</p>
                            <p>United States</p>
                            <p>NMLS ID #2254210</p>
                        </div>
                        <div class="mobile_bottom_info">
                            <img src="content/Images/new/ehl.png" alt="" />
                            <p>For Equal Housing Opportunity.</p>
                            <p>© 2026 All Rights Reserved. For industry professionals only and is not an advertisement to extend
                                credit directly to consumers. For licensing, visit nmlsconsumeraccess.org.</p>
                        </div>
                    </div>
                    <div class="mobile_div">
                        <div>
                            <span class="close-btn"></span>
                            <div>
                                <label for="name">
                                    <span>*</span>Name: <br />
                                    <input id="name1" class="v_name1" type="text" />
                                </label>
                                <label for="phone">
                                    Phone Number:<br />
                                    <input id="phone1" type="text" />
                                </label>
                                <label for="email">
                                    <span>*</span> Preferred E-mail:<br />
                                    <input id="email1" class="v_mail1" type="text" />
                                </label>
                                <label for="number">
                                    Loan #:<br />
                                    <input id="number1" type="text" />
                                </label>
                                <label for="comment">
                                    <span>*</span>Message:<br />
                                    <textarea id="comment1" class="v_message1" rows="3" cols="20"></textarea>
                                </label><br />
                                <input type="button" id="submit1" value="SUBMIT" />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default HeroLogin;